import { useState, useEffect } from "react"
import { useUpdateGroupMutation, useDeleteGroupMutation, useDeleteGroupCompleteMutation } from "./groupsApiSlice"
import { Outlet, useNavigate, useParams } from "react-router-dom"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowAltCircleRight, faCalculator, faCopy, faSave, faTrashCan } from "@fortawesome/free-solid-svg-icons"
import useAuth from "../../hooks/useAuth"
import { useGenerateFinalGradeMutation } from "../finalGrade/finalGradeApiSlice"
import Button from '@mui/material/Button';

const EditGroupForm = ({ group, companies }) => {

    const { isManager, isAdmin } = useAuth()
    const {groupId, id, type} = useParams()
    const [updateGroup, {
        isLoading,
        isSuccess,
        isError,
        error
    }] = useUpdateGroupMutation()

    const [deleteGroup, {
        isSuccess: isDelSuccess,
        isError: isDelError,
        error: delerror
    }] = useDeleteGroupMutation()
    const [deleteGroupComplete, {
         isSuccess: isDelCompleteSuccess,
         data: delData
        // isError: isDelError,
        // error: delerror
    }] = useDeleteGroupCompleteMutation()


    const [generateFinalGrade, {
        isSuccess: isGenerateGradeSuccess,
        isError: isGenerateGradeError,
        error: generateGradeerror
    }] = useGenerateFinalGradeMutation()

    const navigate = useNavigate()



    const [name, setName] = useState(group.name)
    const [year, setYear] = useState(group.year)
    const [active, setActive] = useState(group.active)
    const [company, setCompany] = useState(group.company)
    const [courseName, setCourseName] = useState(group.courseName)
    const [semester, setSemester] = useState(group.semester)
    const [archive, setArchive] = useState(group.archive)

    useEffect(() => {

        if (isSuccess || isDelSuccess) {
            setName('')
            setYear('')
            setCompany('')
            navigate(`/${type}/${groupId}/groups`)
        }

    }, [isSuccess, isDelSuccess, navigate])
    useEffect(() => {

        if (isDelCompleteSuccess) {
            navigate(`/${type}/0/groups`)
            alert(JSON.stringify(delData))
           
        }

    }, [isDelCompleteSuccess, navigate])

    useEffect(()=>{
        if(isGenerateGradeSuccess){
            navigate(`/${type}/${groupId}/groups/${id}/final-grade`)
        }

    },[isGenerateGradeSuccess])
    // const onTitleChanged = e => setTitle(e.target.value)
    // const onTextChanged = e => setText(e.target.value)
    // const onCompletedChanged = e => setCompleted(prev => !prev)
    // const onUserIdChanged = e => setUserId(e.target.value)

    const canSave = [name, year, company].every(Boolean) && !isLoading

    const onSaveGroupClicked = async (e) => {
        if (canSave) {
            await updateGroup({ id: group.id, company, name, year , active, semester, courseName, archive })
        }
    }

    const onDeleteGroupClicked = async () => {
        await deleteGroup({ id: group.id })
    }
    const onGenerateFinalGradeClicked = async () => {
        if( window.confirm("פעולה זו מוחקת את נתוני העבר ומעדכנת שוב, האם להמשיך?")){
            await generateFinalGrade({ groupId: group.id })
        }
       
    }
    const onDeleteGroupCompleteClicked = async () => {
        if( window.confirm("האם אתה בטוח פעולה זו מוחקת את כל הנתונים של הקבוצה ללא אפשרות שחזור כולל כל התרגילים")){
            deleteGroupComplete({ id: group.id })
        }
       
    }

    const created = new Date(group.createdAt).toLocaleString('en-US', { day: 'numeric', month: 'long', year: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' })
    const updated = new Date(group.updatedAt).toLocaleString('en-US', { day: 'numeric', month: 'long', year: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' })

    const options = companies.map(c => {
        return (
            <option
                key={c.id}
                value={c.id}
            > {c.name}</option >
        )
    })

    const errClass = (isError || isDelError) ? "errmsg" : "offscreen"
    const validTitleClass = !name ? "form__input--incomplete" : ''
    const validYearClass = !year ? "form__input--incomplete" : ''
    const validCourseNameClass = !name ? "form__input--incomplete" : ''

    const errContent = (error?.data?.message || delerror?.data?.message) ?? ''


    let deleteButton = null
    if (isManager || isAdmin) {
        deleteButton = (
            <button
                className="icon-button"
                title="Delete"
                onClick={onDeleteGroupClicked}
            >
                <FontAwesomeIcon icon={faTrashCan} />
            </button>
        )
    }

    const content = (
        <>
            <p className={errClass}>{errContent}</p>

            <form className="form" onSubmit={e => e.preventDefault()}>
                <div className="form__title-row">
                    <h2>Edit Group </h2>
                    <div className="form__action-buttons">
                        <button
                            className="icon-button"
                            title="Save"
                            onClick={onSaveGroupClicked}
                            disabled={!canSave}
                        >
                            <FontAwesomeIcon icon={faSave} />
                        </button>
                        {deleteButton}
                        <button
                            className="icon-button"
                            title="Back"
                            onClick={()=>{navigate(`/${type}/${groupId}/groups`)}}
                        >
                            <FontAwesomeIcon icon={faArrowAltCircleRight} />
                        </button>
                        <button
                            className="icon-button"
                            title="Duplicate"
                            onClick={()=>{navigate(`/${type}/${groupId}/groups/${id}/duplicate-all`)}}
                           
                        >
                            <FontAwesomeIcon icon={faCopy} />
                        </button>
                        <Button variant="contained"  onClick={onGenerateFinalGradeClicked} startIcon={<FontAwesomeIcon style={{marginLeft:"10px"}} icon={faCalculator} />} > חולל גליון</Button>
                        <Button variant="contained" onClick={onDeleteGroupCompleteClicked} color="error">מחק לצמיתות</Button>
                        {/* <button
                            className="icon-button"
                            title="Generate Final Grade"
                            onClick={onGenerateFinalGradeClicked}
                        >
                            <FontAwesomeIcon icon={faCalculator} />
                        </button> */}
                    </div>
                </div>
                <label className="form__label" htmlFor="name">
                  שם קורס + מזהה קבוצה ייחודי  [ריאקט ב' פרונט  1 וכד'] </label>
                <input
                    className={`form__input ${validTitleClass}`}
                    id="name"
                    name="name"
                    type="text"
                    autoComplete="off"
                    value={name}
                    onChange={e=>setName(e.target.value)}
                />
                   <label className="form__label" htmlFor="courseName">
                   שם הקורס הנלמד [HTML CSS וכד']:</label>
                <input
                    className={`form__input ${validCourseNameClass}`}
                    id="courseName"
                    name="courseName"
                    type="text"
                    autoComplete="off"
                    value={courseName}
                    onChange={e=>setCourseName(e.target.value)}
                />
                <label className="form__label" htmlFor="year">
                    Year: [תשפ"ד וכד']</label>
                <input
                    className={`form__input ${validYearClass}`}
                    id="year"
                    name="year"
                    type="text"
                    autoComplete="off"
                    value={year}
                    onChange={e=>setYear(e.target.value)}
                />
                
                <label className="form__label" htmlFor="semester">
                    Semester: [מחצית א' וכד']</label>
                <input
                    className={`form__input`}
                    id="semester"
                    name="semester"
                    type="text"
                    autoComplete="off"
                    value={semester}
                    onChange={e=>setSemester(e.target.value)}
                />
                              <label className="form__label form__checkbox-container" htmlFor="company">
                    COMPANY:</label>
                <select
                    id="company"
                    name="company"
                    className="form__select"
                    value={company}
                    onChange={e=>setCompany(e.target.value)}
                >
                    {options}
                </select>

                <div className="form__row">
                    <div className="form__divider">
                        <label className="form__label form__checkbox-container" htmlFor="company-active">
                            ACTIVE:
                            <input
                                className="form__checkbox"
                                id="company-active"
                                name="active"
                                type="checkbox"
                                checked={active}
                                onChange={e => setActive(prev => !prev)}
                            />
                        </label>

                       
                    </div>
                   
                </div>
                <div className="form__row">
                    <div className="form__divider">
                        <label className="form__label form__checkbox-container" htmlFor="company-archive">
                        Archive:
                            <input
                                className="form__checkbox"
                                id="company-archive"
                                name="archive"
                                type="checkbox"
                                checked={archive}
                                onChange={e => setArchive(prev => !prev)}
                            />
                        </label>

                       
                    </div>
                   
                </div>
                <div className="form__row">
      
                    <div className="form__divider">
                        <p className="form__created">Created:<br />{created}</p>
                        <p className="form__updated">Updated:<br />{updated}</p>
                    </div>
                </div>
            </form>
            <Outlet />
        </>
    )

    return content
}

export default EditGroupForm